import styles from './style.module.scss';
import { List, Divider, Row, Col, Spin } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import usePages from '../usePages';

const SinglePage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const { singleData, loading, shoppingCenters } = usePages(false);

  const isSuccessUpdatePage = searchParams.get('success') === 'true';

  const shoppingCenterTitle =
    singleData?.shopping_center?.title ||
    shoppingCenters?.find((i) => i.id === singleData?.shopping_center_id)?.title;

  const dataKeys = [
    { key: 'title', text: t('Titolo') },
    { key: 'slug', text: t('Url') },
    {
      key: 'shopping_center_id',
      text: t('Shopping center'),
      value: shoppingCenterTitle,
    },
    { key: 'body', text: t('Descrizione'), isHtml: true },
  ];

  const title = isSuccessUpdatePage
    ? t('PAGE WAS SUCCESSFULLY UPDATED.')
    : t('PAGE');

  return (
    <div>
      <PageHeader title={title} />
      <div className={styles.content}>
        <Spin spinning={loading}>
          <List
            header={<div>{t('PAGE')}</div>}
            dataSource={dataKeys}
            renderItem={(item) => (
              <List.Item
                style={item.isHtml ? { alignItems: 'flex-start' } : undefined}
              >
                <b className={styles.itemName}>{item.text}</b>
                {item.isHtml ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: singleData?.[item.key] || '—',
                    }}
                  />
                ) : (
                  item.value ?? singleData?.[item.key] ?? '—'
                )}
              </List.Item>
            )}
          />
        </Spin>
        <Divider />
        <Row gutter={16}>
          {singleData?.can_update !== false && (
            <Col>
              <Button>
                <Link to={`/admin/pages/${singleData?.id}/edit`}>
                  {t('MODIFIICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/admin/pages'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default SinglePage;
